module.exports = __webpack_public_path__ + "img/minibus.1ff4778e.png";